import { useEffect, useState } from 'react';
import { getSecondsLeft } from './useCountdown.helpers.ts';

const TICK_INTERVAL = 1000;

export const useCountdown = (until: number): number => {
  const [now, setNow] = useState(Date.now);

  useEffect(() => {
    const start = Date.now();

    setNow(start);

    if (getSecondsLeft(until, start) === 0) {
      return;
    }

    const interval = setInterval(() => {
      const next = Date.now();

      setNow(next);

      if (getSecondsLeft(until, next) === 0) {
        clearInterval(interval);
      }
    }, TICK_INTERVAL);

    return () => {
      clearInterval(interval);
    };
  }, [until]);

  return getSecondsLeft(until, now);
};
